import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { Sparkles } from "lucide-react";

export default function Nfts() {
  return (
    <Layout>
      <div className="flex items-center gap-3 mb-4">
        <Sparkles className="text-[var(--ks-primary)]" />
        <h1 className="text-xl font-semibold" data-testid="nfts-title">NFTs</h1>
      </div>
      <div className="ks-card p-8 text-center" data-testid="nfts-empty">
        <div className="text-5xl mb-3">🖼️</div>
        <div className="text-lg font-semibold mb-1">No NFT activity yet</div>
        <p className="text-sm text-[var(--ks-text-soft)] mb-4">
          This explorer currently tracks only ERC-20 tokens. NFT (ERC-721 &amp; ERC-1155) tracking will be enabled in a future release.
        </p>
        <div className="flex justify-center gap-3">
          <Link to="/tokens" className="ks-link">Explore ERC-20 Tokens →</Link>
          <Link to="/txs" className="ks-link">Recent Transactions →</Link>
        </div>
      </div>
    </Layout>
  );
}
